export default "__VITE_ASSET__Q9WucHk9__"